import { StyleSheet, View, type ViewProps } from "react-native";

type ContainerSize = "auth" | "form" | "content" | "page" | "full";

export function Container({
  size = "page",
  style,
  ...props
}: ViewProps & { size?: ContainerSize }) {
  return (
    <View style={[stylesheet.container, sizeStyles[size], style]} {...props} />
  );
}

const stylesheet = StyleSheet.create({
  container: {
    width: "100%",
    alignSelf: "center",
  },
  auth: { maxWidth: 450 },
  form: { maxWidth: 560 },
  content: { maxWidth: 800 },
  page: { maxWidth: 1180 },
  full: { maxWidth: "100%" },
});

const sizeStyles = {
  auth: stylesheet.auth,
  form: stylesheet.form,
  content: stylesheet.content,
  page: stylesheet.page,
  full: stylesheet.full,
};
